import React, { Component } from 'react';
import Calculate from './views/Calculate';
import Result from './views/Result';
import styled, { createGlobalStyle } from 'styled-components'
import DIGIFAW from './assets/fonts/DIGIFAW.TTF'
import BigruixianBlackGB from './assets/fonts/BigruixianBlackGB.TTF'

// 动态样式字体重复加载in dev
// styled-components bug 4.0.3
// 详见https://github.com/styled-components/styled-components/issues/1593
const GlobalStyle = createGlobalStyle`
  body {
    margin: 0;
    font-family: -apple-system,BlinkMacSystemFont,PingFang SC,Helvetica Neue,STHeiti,Microsoft Yahei,Tahoma,Simsun,sans-serif;
    @font-face {
        font-family: "DIGIFAW";
        src: url(${DIGIFAW});
        font-display: block;
    }
    @font-face {
        font-family: "BigruixianBlackGB";
        src: url(${BigruixianBlackGB});
        font-display: block;
    }
  }
  input {
    outline:none;
    }
`
const Wrapper = styled.div`
    width: 100%;
    margin: 0;
    position: fixed;
	top: 0;
	right:0;
	bottom:0;
	left: 0;
	overflow-y: scroll;
  	-webkit-overflow-scrolling: touch;
`
class App extends Component {
    constructor(){
        super()
        this.state = {
            step: 0
        }
        this.calc = {
//             allocationRatioBond: 0.25,
// allocationRatioGold: 0.35,
// allocationRatioHs300: 0.1,
// allocationRatioOil: 0.1,
// allocationRatioSp500: 0.1,
// allocationRatioZz500: 0.1,
// amount: 1000000,
// aror: 0.0722,
// arorHs300: 0.108,
// arorSp500: 0.0686,
// arorZl: 0.0829,
// arorZz500: 0,
// custMobileno: "",
// custName: "",
// flag: "",
// income: 5774700,
// insertTimestamp: "",
// maxdrawdown: -0.5038,
// maxdrawdownHs300: -0.723,
// maxdrawdownSp500: -0.5678,
// maxdrawdownZl: -0.0866,
// maxdrawdownZz500: 0,
// risklevel: "3",
// serialno: "201811282005171904565073",
// sharperatio: 0.459,
// sharperatioHs300: 0.3814,
// sharperatioSp500: 0.3516,
// sharperatioZl: 1.4929,
// sharperatioZz500: 0
        }
        this.nav = {}
    }
    nextStep = (calc, nav) => {
        this.setState(pre => {
            this.calc = calc
            this.nav = nav
            window.scroll(0, 0);
            return {
                step: pre.step + 1
            }
        })
    }
    lastStep = () => {
        this.setState(pre => {
            window.scroll(0, 0);
            return {
                step: pre.step - 1
            }
        })
    }
    render() {
        return (
            <Wrapper className="App">
                <GlobalStyle></GlobalStyle>
                {
                    this.state.step === 0 && <Calculate nextStep={this.nextStep}></Calculate>
                }
                {
                    this.state.step > 0 && <Result calc={this.calc} nav={this.nav} lastStep={this.lastStep}></Result>
                }
            </Wrapper>
        );
    }
}

export default App;
